var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame37(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 76,
    height: 76,
    rx: 38,
    fill: "#FFFAE6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 76,
    height: 76,
    rx: 38,
    stroke: "#FFFAE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1693 43.5L39.0026 42.2917L41.9609 39.3333H31.8359V37.6667H41.9609L39.0026 34.7083L40.1693 33.5L45.1693 38.5L40.1693 43.5Z",
    fill: "#EF8551"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame37);
export default __webpack_public_path__ + "static/media/frame-37.58d2cb91f1f04c706673a2f8be8fc45e.svg";
export { ForwardRef as ReactComponent };